import React, { useRef } from 'react';
import clsx from 'clsx';
import { useSanitize } from '../../hooks/useSanitize';
import * as Styled from './AHeader.styles';
import { AHeaderProps, AHeaderSize, AHeaderTag } from './AHeader.types';

const COMPONENT_NAME = 'a-web-ui-kit-AHeader';
const TEST_ID = 'web-ui-kit-AHeader';

const AHeaderAllowedTags = ['sub', 'sup', 'br', 'span'];
const sanitizeOpts = { ALLOWED_TAGS: AHeaderAllowedTags };

export const AHeader: React.FC<AHeaderProps> = ({ size = AHeaderSize.TitleM, text, element, className, ...rest }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const sizeTagMap = {
    [AHeaderSize.TitleXL]: AHeaderTag.h1,
    [AHeaderSize.TitleL]: AHeaderTag.h1,
    [AHeaderSize.TitleM]: AHeaderTag.h2,
    [AHeaderSize.TitleS]: AHeaderTag.h3,
  };
  const sizeClassMap = {
    [AHeaderSize.TitleXL]: 't-title-xl',
    [AHeaderSize.TitleL]: 't-title-l',
    [AHeaderSize.TitleM]: 't-title-m',
    [AHeaderSize.TitleS]: 't-title-s',
  };
  const mergedClassName = clsx(className, sizeClassMap[size] ?? 't-title-m');
  const Tag = element ? element : sizeTagMap[size] || sizeTagMap[AHeaderSize.TitleM];

  const { isDangerouslySet, result: cleanHeaderText } = useSanitize(text, sanitizeOpts);

  return isDangerouslySet ? (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      ref={containerRef}
      as={Tag}
      size={size}
      className={mergedClassName}
      {...rest}
      dangerouslySetInnerHTML={{ __html: cleanHeaderText }}
    />
  ) : (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      ref={containerRef}
      as={Tag}
      size={size}
      className={mergedClassName}
      {...rest}
    >
      {cleanHeaderText}
    </Styled.Wrapper>
  );
};

export { AHeaderSize, AHeaderTag, TEST_ID as A_HEADER_TEST_ID };
